import React from 'react';
import './SearchBar.css';

const SearchBar = ({ input, setInput, onSearch }) => {
  return (
    <div className={`search-container`}>
      <form className="search-form" onSubmit={onSearch}>
        <input
          type="text"
          className="search-input"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Search MTG cards..."
        />
        <button className="search-button" type="submit">
          Scry
        </button>
      </form>
    </div>
  );
};

export default SearchBar;